<template>
  <div class="personal_container">
    <a-modal
      :title="title"
      :visible="value"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel"> 取消 </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="confirmLoading"
          @click="handleOk"
        >
          确定
        </a-button>
      </template>
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <!-- 姓名 -->
        <a-form-item label="昵称">
          <a-input
            v-decorator="[
              'realName',
              {
                initialValue: userInfo.realName,
                rules: [
                  // { required: true, message: '姓名不能为空', trigger: 'change' }
                ]
              }
            ]"
          />
        </a-form-item>
        <!-- 手机号 -->
        <a-form-item label="手机号">
          <a-input
          disabled="true"
            v-decorator="[
              'phone',
              {
                initialValue: userInfo.phone,
                rules: [
                  {
                    pattern:
                      /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
                    message: '请输入合法的手机号码'
                  }
                ]
              }
            ]"
          />
        </a-form-item>
        <!-- 邮箱 -->
        <a-form-item label="邮箱">
          <a-input
            v-decorator="[
              'email',
              {
                initialValue: userInfo.email,
                rules: [
                  {
                    pattern: /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/,
                    message: '请输入合法的邮箱地址'
                  }
                ]
              }
            ]"
          />
        </a-form-item>
        <!-- 上传头像 -->
        <a-form-item label="Logo" extra="请上传 60 ✖️ 60 的图片">
          <a-upload
            :action="uploadConfig.api"
            list-type="picture-card"
            :file-list="fileList"
            @preview="handlePreview"
            @change="handleChange"
            :remove="handleRemove"
            v-decorator="['picUrl']"
          >
            <div v-if="fileList.length < 1">
              <a-icon type="plus" />
              <div class="ant-upload-text">上传Logo</div>
            </div>
          </a-upload>
          <!-- 预览 -->
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancelUpload"
          >
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </a-form-item>
        <!-- 用户简介 -->
        <a-form-item label="简介">
          <a-textarea
            placeholder="请输入用户简介"
            allow-clear
            v-decorator="[
              'userDes',
              {
                initialValue: userInfo.userDes,
                rules: [
                  {
                    required: false,
                    trigger: 'change'
                  },
                  {
                    max: 255,
                    message: '用户简介不能多于255个字符'
                  }
                ]
              }
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { modifyUserApi } from '@/api/enterpriseManage';
import { getToken } from '@/utils/auth';
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
export default {
  name: 'Personal',
  components: {},
  data() {
    var baseDomain = process.env.BASE_API;
    if (baseDomain == '/') {
      baseDomain = window.location.origin;
    }
    return {
      form: this.$form.createForm(this),
      confirmLoading: false,
      fileList: [],
      uploadConfig: {
        api: `${baseDomain}/app-server/uploads/picture`,
        headers: {
          Authorization: getToken()
        }
      },
      previewVisible: false,
      previewImage: '',
      logo_url: ''
    };
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  watch: {},
  created() {},
  mounted() {
    if (this.userInfo && this.userInfo.picUrl) {
      this.logo_url = this.userInfo.picUrl;
      this.fileList = [
        {
          uid: '-1',
          name: 'images.png',
          status: 'done',
          url: this.userInfo.picUrl
        }
      ];
    }
  },
  methods: {
    // 图片预览
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    // 上传图片
    handleChange({ file, fileList }) {
      if (file.status === 'uploading' || file.status === 'done') {
        if (file.response) {
          const { FileURL } = file.response;
          this.logo_url = FileURL;
        }
        this.fileList = fileList;
      }
      this.fileList = fileList;
    },
    // 删除图片
    handleRemove() {
      this.logo_url = '';
      this.fileList = [];
    },
    handleCancelUpload() {
      this.previewVisible = false;
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true;
          const params = Object.assign({}, values, {
            eid: this.userInfo.eid,
            userID: this.userInfo.userID,
            picUrl: this.logo_url || ''
          });
          modifyUserApi(params)
            .then(() => {
              this.$message.success('修改成功');
              // GET一下
              this.$store.dispatch('GetUserInfo');
            })
            .catch((error) => {
              if (error.code == 3004) {
                this.$message.error('电话号码已存在');
              } else if (error.code == 3003) {
                this.$message.error('邮箱已存在');
              } else {
                this.$message.error('修改失败');
              }
            });
          this.handleCancel();
        }
      });
    },
    handleCancel() {
      this.$emit('input', false);
      this.confirmLoading = false;
    }
  }
};
</script>

<style scoped lang="scss">
.personal_container{
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/Header/components/changePersonalInfo.vue